<template>
    <BreadCrumb PageTitle="Liste des emplois du temps" />
    <ListeEmploi/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeEmploi from "@/components/EmploiDuTemps/ListeEmploi.vue";

    export default defineComponent({
      name: "ListeEmploiPage",
      components: {
        BreadCrumb,
        ListeEmploi,
      },
    });
  </script> 